// extracted by mini-css-extract-plugin
module.exports = {"navbar-desktop":"navbar-desktop","navbar-scrolled":"navbar-scrolled","navbar-nav":"navbar-nav","navbar-nav-item":"navbar-nav-item"};